import React, { useState } from 'react';

import './index.scss';
import classNames from 'classnames';

const BubbleVoiceCall = ({ URL, data, selectedConversation }) => {
  const [showDetails, setShowDetails] = useState(false);
  const [showTranscript, setShowTranscript] = useState(false);
  const { summary, userPhone, userName, alltags, tags, auto_transcript } = data;
  const unResponsive = tags.includes('APPOINTMENT_REMINDER_UNCONFIRMED');
  const confirmed = tags.includes('APPOINTMENT_REMINDER_CONFIRMED');
  const cancelRequest = tags.includes('APPOINTMENT_REMINDER_CANCEL_REQUESTED');
  const rescheduleRequest = tags.includes('APPOINTMENT_REMINDER_RESCHEDULE_REQUESTED');
  const transcript = JSON.parse(auto_transcript);
  return (
    <div className="incoming-voicecall">
      <div
        className="reminder__container">
        <div className="reminder__header">
          {(cancelRequest || rescheduleRequest) && <div>
            <span className="reminder__header_needsattenton">
              Needs attention:{' '}
            </span>
            {cancelRequest ? 'Cancellation' : 'Reschedule'} request
          </div>}
          {unResponsive && <div className="unresponsive">Appointment unconfirmed</div>}
          {confirmed && <div className="confirmed">Appointment confirmed</div>}
          <div className="reminder__header_status">
            {summary.call_outcomes?.map((outcome, index) => (
              <span key={index}>{outcome.biz_msg_header}</span>
            ))}
            <span
              className="reminder__showDetails"
              onClick={() => setShowDetails(!showDetails)}
            >
              {showDetails ? 'Hide details' : 'Show details'}
            </span>
          </div>
        </div>
        {showDetails && (
          <div className="reminder__details">
            {userName.trim() && <p>
              Caller name: {userName}
            </p>}
            <p>
              Caller phone: {userPhone}
            </p>
            {summary.call_outcomes?.map((outcome, index) => (
              <div className="reminder__details__message_body">
                <p>Hi there,</p>
                <p key={index} style={{ margin: '0 0 10px 0' }}>{outcome.biz_msg_body}</p>
                <p>Cheers,</p>
                <p style={{ margin: '2px 0' }}>Thank you</p>
              </div>
            ))}
            {summary.appointment_details.length > 0 &&
              <p>
                {summary.appointment_details.length < 2 ? 'Appointment' : 'Appointments'}: <ol>{summary.appointment_details.map((appointment, index) => <li key={index}>{appointment}</li>)}</ol>
              </p>}
            <div className="message-body">
              {summary.message_body}
            </div>
            {URL &&
              <div className="audio-player">
                <audio controls>
                  <source src={URL} type="audio/mpeg" />
                  Your browser does not support the audio element.
                </audio>
              </div>}
            <span
              className="reminder__showDetails"
              onClick={() => setShowTranscript(!showTranscript)}
            >
              {showTranscript ? 'Hide transcript' : 'see transcript'}
            </span>
            <div className={`box ${showTranscript ? 'visible' : 'hidden'}`}>
              {transcript.length > 1 && <ul className="transcript-list">{transcript.map((message, index) => <li key={index}><div className="transcript-list_message"><span className={classNames('transcript-list_message_sender', { 'bot': message.sender === 'bot' })}>{message.sender === 'bot' ? 'TrueLark:' : 'Caller:'}</span><span className={classNames('transcript-list_message_info', { 'bot': message.sender === 'bot' })}>{message.text}</span></div></li>)}</ul>}
            </div>
            {/* {selectedConversation.status === 'FINISHED' && selectedConversation.textType === 'VOICE_CALL' &&
              <div className="reminder__details_full-transcript">
                <a href={`${window.Config.API_URL}/voice_transcripts?number=${selectedConversation.userPhone}&bzId=${selectedConversation.bzId}&format=json`} target='_blank'>click here to view complete transcript</a>
              </div>
            } */}
          </div>
        )}
      </div>
    </div>
  );
};

export default BubbleVoiceCall;
